import { onMounted, nextTick } from 'vue';

export function useFocusOnMounted(inputRef) {
	onMounted(() => {
		nextTick(() => {
			if (inputRef.value && inputRef.value.focus) {
				inputRef.value.focus();
			}
		});
	});
	return {};
}
